import { Injectable } from '@angular/core';
import { AppSettings } from '../../app.settings';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  constructor() {}

  static isHttpPath(url: string) {
    return new RegExp('^https?://').test(url);
  }

  static isTranslationsEndpoint(url: string): boolean {
    return new RegExp(AppSettings.pathToAssets).test(url);
  }

  // @Todo: Write unit test.
  static toCamel(s: string): string {
    return s.replace(/([-_][a-z])/gi, ($1) => $1.toUpperCase().replace('-', '').replace('_', ''));
  }

  // @Todo: Write unit test.
  static prune(input) {
    if (typeof input !== 'object') {
      return;
    }

    Object.keys(input).forEach((key) => {
      if (!input[key]) {
        delete input[key];
        return;
      }

      if (typeof input !== 'object') {
        return;
      }

      this.prune(input[key]);
      return;
    });
  }
}
